import React, { createContext, useReducer } from "react";
import { reducer } from "./reducer";
import { Actions } from "./types";
import { responseType } from "../../../../../utils/formTypes";
import { AtsStckItem } from "../../masters/items/queries/types";
import {
  AtsCompanyEdge,
  TableType,
} from "../../../customer/companies/queries/types";
import { AtsSubsidiaryEdge } from "../../masters/subsidary/queries/types";
import { JunctionEdge } from "../../masters/subsidary/junctions/queries/types";
import { JunctionStatus } from "../../../../../utils/Enum.types";

export interface StateType {
  company: AtsCompanyEdge | null;
  subsidary: AtsSubsidiaryEdge | null;
  item: AtsStckItem | null;
  asset: responseType | null;
  site: responseType | null;
  junction: JunctionEdge | null;
  companyId: number;
  marketType: TableType;
  assetTypeId: number;
  ticketId: number;
  empId: number;
  itemId: number;
  supplierId: number;
  ticketDetailsId: number;
  followUpTicket: number;
  itemDetailsId: number;
  junctionStatus: JunctionStatus | null;
  junctionId: number;
  junctionType: string;
  raiseTicketLevel: TableType;
}

export const initialState: StateType = {
  company: null,
  subsidary: null,
  item: null,
  asset: null,
  site: null,
  junction: null,
  companyId: 0,
  marketType: TableType.NONE,
  assetTypeId: 0,
  ticketId: 0,
  empId: 0,
  itemId: 0,
  supplierId: 0,
  ticketDetailsId: 0,
  followUpTicket: 0,
  itemDetailsId: 0,
  junctionStatus: null,
  junctionId: 0,
  junctionType: "",
  raiseTicketLevel: TableType.NONE,
};

const MapsContext = createContext<{
  state: StateType;
  dispatch: React.Dispatch<Actions>;
}>({
  state: initialState,
  dispatch: () => null,
});
interface Props {
  children: React.ReactNode;
}
const AppProvider: React.FC<Props> = ({ children }) => {
  const [state, dispatch] = useReducer(reducer, initialState);

  return (
    <MapsContext.Provider value={{ dispatch, state }}>
      {children}
    </MapsContext.Provider>
  );
};

export { AppProvider, MapsContext };
